import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { forgotPassword } from '../services/authService';
import Navbar from '../components/Navbar';
import './Login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await forgotPassword(email);
      setSuccess(response.message);

      // Navigate to verify OTP page after 2 seconds
      setTimeout(() => {
        navigate('/verify-reset-otp', { state: { email } });
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Navbar />

      <div className="login-wrapper">
        <div className="login-card">
          {/* Decorative elements */}
          <div className="login-decor login-decor-1"></div>
          <div className="login-decor login-decor-2"></div>

          <div className="login-header">
            <div className="login-icon">
              <i className="bi bi-key"></i>
            </div>
            <h2>Forgot Password</h2>
            <p>Enter your email to receive a reset code</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="login-alert login-alert-error">
                <i className="bi bi-exclamation-circle"></i>
                <span>{error}</span>
              </div>
            )}

            {success && (
              <div className="login-alert login-alert-info">
                <i className="bi bi-check-circle"></i>
                <span>{success}</span>
              </div>
            )}

            <div className="login-field">
              <label htmlFor="email">
                <i className="bi bi-envelope"></i>
                Email Address
              </label>
              <div className="login-input-wrapper">
                <input
                  type="email"
                  id="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading || success}
                  autoComplete="email"
                />
              </div>
            </div>

            <button
              type="submit"
              className="login-btn"
              disabled={loading || success}
            >
              {loading ? (
                <>
                  <span className="login-spinner"></span>
                  Sending...
                </>
              ) : (
                <>
                  Send Reset Code
                  <i className="bi bi-arrow-right"></i>
                </>
              )}
            </button>
          </form>

          <div className="login-divider">
            <span>or</span>
          </div>

          <div className="login-footer">
            <p>
              Remember your password? <Link to="/login">Back to Login</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
